import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, AfterViewChecked, OnDestroy, isDevMode } from '@angular/core';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { BaseService } from '@app/system/services/base.service';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/modules/auth/utilities/services/api.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { ResourceDetailComponent } from '@app/modules/resource/resource-detail/resource-detail.component';
import { BeadComponent } from '@app/modules/knowledge-bead/bead/bead.component';
import { UntypedFormControl } from '@angular/forms';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { AppInitializerService } from '@app/app-initializer.service';
import { KnowledgeCardFormsComponent } from '@app/modules/knowledge-card/knowledge-card-forms/knowledge-card-forms.component';
import { QuestionsFormsComponent } from '@app/modules/questions/questions-forms/questions-forms.component';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { BuilderService } from '@app/components/controls/utilities/services/builder.service';
import { PeopleFormsComponent } from '@app/modules/people/people-forms/people-forms.component';
import { ApiService as WorkgroupApiService } from '@app/modules/workgroup/utilities/services/api.service';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { forkJoin } from 'rxjs';
import { PlaylistFormsComponent } from '@app/modules/playlist/playlist-forms/playlist-forms.component';
import { AssignmentUpdateComponent } from '@app/modules/assignment/assignment-update/assignment-update.component';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewChecked, OnDestroy {

	@Input() sideNavState = false;
	@ViewChild('loaderEl') loaderEl: ElementRef;
	@ViewChild('content') content: ElementRef;

	items = Array.from({ length: 100000 }).map((_, i) => `Item #${i}`);

	language = 'en';
	notificationCount = 0;
	interval;
	isLogin = false;
	notifications = [];
	firstTimeOpened = false;
	limit = 10;
	totalRecordCount = 0;
	loader = false;
	countSubscribe;
	currentUser;
	userName;
	closeTemplate = false;
	notificationPanelState = false;
	subscribe;
	testJson = {};
	showSearch = true;
	searchControl: UntypedFormControl;
	searchField: AutoCompleteModel;
	searchResult = {
		resource: [],
		people: []
	};
	searchValue = '';
	searchLoader = false;
	searchSubscribe;
	searchTimeout;
	shortInfo = [];
	creationList = [];
	canLoadTask = true;
	blockCardAction = false;
	segmentSubscribe;
	segmentReadSubscribe;
	timeLogSubscribe;
	timeLogReadSubscribe;
	searchApiStatus = false;
	notificationPanelHeight;

	constructor(
		public gfService: GlobalFunctionService,
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		private globalApiService: GlobalApiService,
		private baseService: BaseService,
		private cdref: ChangeDetectorRef,
		private router: Router,
		private authApiService: ApiService,
		public appInit: AppInitializerService,
		private popup: MatDialog,
		private activatedRoute: ActivatedRoute,
		private controlBuilder: BuilderService,
		private workgroupApiService: WorkgroupApiService,
		private resourceApiService: ResourceApiService,
		private elementRef: ElementRef
	) {
		if (sessionStorage.getItem('locale')) {
			this.language = sessionStorage.getItem('locale');
		}
		this.currentUser = this.gfService.sessionUser;
		if (this.currentUser && this.currentUser.profile) {
			if (this.currentUser.profile.company && this.currentUser.profile.company.name) {
				this.shortInfo.push(
					{
						value: this.currentUser.profile.company.name
					}
				);
			}
			if (this.currentUser.profile.department && this.currentUser.profile.department.name) {
				this.shortInfo.push(
					{
						value: this.currentUser.profile.department.name
					}
				);
			}
			if (this.currentUser.profile.city && this.currentUser.profile.city.name) {
				this.shortInfo.push(
					{
						value: this.currentUser.profile.city.name
					}
				);
			}
			if (this.currentUser.profile.location && this.currentUser.profile.location.name) {
				this.shortInfo.push(
					{
						value: this.currentUser.profile.location.name
					}
				);
			}
			// if (this.currentUser.domainID) {
			// 	this.shortInfo.push(
			// 		{
			// 			caption: this.locale.translate('domain_id'),
			// 			isBold: true,
			// 			value: this.currentUser.domainID
			// 		}
			// 	);
			// }
			this.userName = `${this.currentUser.profile.firstName}${(this.currentUser.profile.lastName) ? ' ' + this.currentUser.profile.lastName : ''}`;
		}
		this.router.events.forEach((event) => {
			if (event instanceof NavigationStart) {
				if (this.notificationPanelState) {
					this.closeTemplate = true;
					this.cdref.detectChanges();
				}
			}
		});
	}

	ngOnInit(): void {
		this.subscribe = this.detectDevice.resolutionState$.subscribe(() => {
			this.setNotificationPanelHeight();
		});
		// const permission = this.baseService.checkAccessControl('P02');
		this.creationOptions();
		this.searchField = {
			additionalMetaData: {},
			fieldColumn: 'search',
			fieldType: 'autoComplete',
			isHidden: false,
			isMultiple: false,
			isReadonly: false,
			isRequired: false,
			options: [],
			selectedValue: [],
			fieldPlaceholder: ''
		};
		this.searchControl = this.controlBuilder.controlBuilder(this.searchField);
		this.searchControl.valueChanges.subscribe(resp => {
			if (resp) {
				if (this.searchSubscribe && !this.searchSubscribe['closed']) {
					this.searchSubscribe.unsubscribe();
				}
				this.searchApiStatus = false;
				this.searchValue = resp;
				this.getSearchResult(resp);
			} else {
				Object.keys(this.searchResult).map(key => {
					this.searchResult[key] = [];
				});
			}
		});
		this.isLogin = this.gfService.isLogin;
		this.gfService.globalBS$.subscribe(resp => {
			if (resp && resp.type === 'IS_LOGIN') {
				this.isLogin = resp.isLogin;
			}
		});
		this.baseService.menuUpdate.subscribe(() => {
			this.creationOptions();
		});
		if (!isDevMode() && navigator && navigator.onLine) {
			this.timeOut();
		}
	}

	ngAfterViewChecked() {
		this.currentUser = this.gfService.sessionUser;
		if (this.currentUser && this.currentUser.profile) {
			if (this.shortInfo.length === 0) {
				if (this.currentUser.profile.company && this.currentUser.profile.company.name) {
					this.shortInfo.push(
						{
							value: this.currentUser.profile.company.name
						}
					);
				}
				if (this.currentUser.profile.department && this.currentUser.profile.department.name) {
					this.shortInfo.push(
						{
							value: this.currentUser.profile.department.name
						}
					);
				}
				if (this.currentUser.profile.city && this.currentUser.profile.city.name) {
					this.shortInfo.push(
						{
							value: this.currentUser.profile.city.name
						}
					);
				}
				if (this.currentUser.profile.location && this.currentUser.profile.location.name) {
					this.shortInfo.push(
						{
							value: this.currentUser.profile.location.name
						}
					);
				}
				// if (this.currentUser.domainID) {
				// 	this.shortInfo.push(
				// 		{
				// 			caption: this.locale.translate('domain_id'),
				// 			isBold: true,
				// 			value: this.currentUser.domainID
				// 		}
				// 	);
				// }
			}
			this.userName = `${this.currentUser.profile.firstName}${(this.currentUser.profile.lastName) ? ' ' + this.currentUser.profile.lastName : ''}`;
		}
	}

	creationOptions() {
		this.creationList = [
			{
				caption: this.locale.translate('create_playlist'),
				key: 'playlist',
				svgIcon: 'playlist',
				visible: true
			}
		];
		if (this.baseService.checkAccessControl('KB001')) {
			this.creationList.push(
				{
					caption: this.locale.translate('knowledge_bead'),
					key: 'knowledgeBead',
					svgIcon: 'resource',
					visible: this.baseService.checkAccessControl('KB001')
				}
			);
		}
		if (this.baseService.checkAccessControl('QS001')) {
			this.creationList.push(
				{
					caption: this.locale.translate('ask_a_question'),
					key: 'askQuestion',
					svgIcon: 'question_and_answer',
					visible: this.baseService.checkAccessControl('QS001')
				}
			);
		}
		if (this.baseService.checkAccessControl('KC001')) {
			this.creationList.push(
				{
					caption: this.locale.translate('assign_knowledge_card'),
					key: 'assignKnowledgeCard',
					svgIcon: 'knowledge_card',
					visible: this.baseService.checkAccessControl('KC001')
				}
			);
		}
		if (this.baseService.checkAccessControl('PC001') && this.baseService.checkModuleAccess('M13')) {
			this.creationList.push(
				{
					caption: this.locale.translate('register_learning'),
					key: 'registerLearning',
					svgIcon: 'register_learning',
					visible: this.baseService.checkAccessControl('PC001')
				}
			);
		}
		if (this.baseService.checkAccessControl('AGN001')) {
			this.creationList.push(
				{
					caption: this.locale.translate('assign_resource'),
					key: 'assignResource',
					svgIcon: 'assignment',
					visible: this.baseService.checkAccessControl('AGN001')
				}
			);
		}
	}

	reloadList() {
		if (navigator.onLine) {
			if (this.searchControl.value) {
				let isEmptyList = true;
				Object.keys(this.searchResult).map(key => {
					if (this.searchResult[key].length) {
						isEmptyList = false;
					}
				});
				if (isEmptyList) {
					this.searchLoader = true;
					this.getSearchResult(this.searchControl.value);
				}
			}
		}
	}

	navigateTo(linkType) {
		if (navigator.onLine) {
			if (this.appInit.configuration.links.hasOwnProperty(linkType)) {
				const url = this.appInit.configuration.links[linkType];
				this.gfService.windowNavigate(url, '_blank');
			}
		}
	}

	triggerCreation(data) {
		if (navigator.onLine) {
			this.closeTemplate = true;
			setTimeout(() => {
				if (data.key === 'knowledgeBead') {
					const dialogRef = this.popup.open(PopupComponent, {
						panelClass: ['custom-panel'],
						data: {
							action: 'dynamic',
							popup: true,
							component: BeadComponent,
							componentData: [
								{
									variableName: 'tabIndex',
									value: 0
								},
								{
									variableName: 'action',
									value: 'share'
								}
							]
						},
						disableClose: true,
						maxWidth: '860px',
						autoFocus: false
					});
					dialogRef.afterClosed().subscribe(async (result) => {
						if (result && typeof result === 'object') {
						}
					});
				} else if (data.key === 'registerLearning') {
					const dialogRef = this.popup.open(PopupComponent, {
						panelClass: ['custom-panel'],
						data: {
							action: 'dynamic',
							popup: true,
							component: PeopleFormsComponent,
							componentData: [
								{
									variableName: 'action',
									value: 'addCertification'
								},
								{
									variableName: 'userID',
									value: this.currentUser.userID
								}
							]
						},
						disableClose: true,
						maxWidth: '860px',
						autoFocus: true
					});
					dialogRef.afterClosed().subscribe(async (result) => {
						if (result && typeof result === 'object') {
						}
					});
				} else if (data.key === 'assignKnowledgeCard') {
					const dialogRef = this.popup.open(PopupComponent, {
						panelClass: ['custom-panel'],
						data: {
							action: 'dynamic',
							popup: true,
							component: KnowledgeCardFormsComponent,
							componentData: [
								{
									variableName: 'action',
									value: 'addKnowledgeCard'
								}
							]
						},
						disableClose: true,
						maxWidth: '860px',
						autoFocus: true
					});
					dialogRef.afterClosed().subscribe(async (result) => {
						if (result && typeof result === 'object') {
						}
					});
				} else if (data.key === 'askQuestion') {
					const dialogRef = this.popup.open(PopupComponent, {
						panelClass: ['custom-panel'],
						data: {
							action: 'dynamic',
							popup: true,
							component: QuestionsFormsComponent,
							componentData: [
								{
									variableName: 'action',
									value: 'addQuestion'
								}
							]
						},
						disableClose: true,
						maxWidth: '860px',
						autoFocus: true
					});
					dialogRef.afterClosed().subscribe(async (result) => {
						if (result && typeof result === 'object') {
						}
					});
				} else if (data.key === 'playlist') {
					const dialogRef = this.popup.open(PopupComponent, {
						panelClass: ['custom-panel'],
						data: {
							action: 'dynamic',
							popup: true,
							component: PlaylistFormsComponent,
							componentData: [
								{
									variableName: 'action',
									value: 'addPlaylist'
								}
							]
						},
						disableClose: true,
						maxWidth: '860px',
						autoFocus: true
					});
					dialogRef.afterClosed().subscribe(async (result) => {
						if (result && typeof result === 'object') {
						}
					});
				} else if (data.key === 'assignResource') {
					const dialogRef = this.popup.open(PopupComponent, {
						panelClass: ['custom-panel'],
						data: {
							action: 'dynamic',
							popup: true,
							component: AssignmentUpdateComponent,
							componentData: [
								{
									variableName: 'action',
									value: 'assignResource'
								}
							]
						},
						disableClose: true,
						maxWidth: '860px',
						autoFocus: true
					});
					dialogRef.afterClosed().subscribe(async (result) => {
						if (result && typeof result === 'object') {
						}
					});
				}
			}, 150);
		}
	}

	joinWorkgroup() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'joinWorkgroup',
				popup: true
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: true
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
			}
		});
	}

	getSearchResult(value) {
		if (navigator.onLine) {
			const apiData = {
				searchString: value,
				resourceCount: 5
			};
			const headers: any = {
				lanCode: sessionStorage.getItem('locale') || 'en'
			};
			this.searchLoader = true;
			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			}
			Object.keys(this.searchResult).map(key => {
				this.searchResult[key] = [];
			});
			this.searchTimeout = setTimeout(() => {
				if (this.searchControl.value && typeof this.searchControl.value === 'string') {
					this.searchSubscribe = this.globalApiService.search(apiData, headers).subscribe(
						(response) => {
							this.searchLoader = false;
							if (response && response.records && this.searchControl.value) {
								this.dataBuild(response.records);
								this.cdref.detectChanges();
							}
						},
						(error) => {
							this.gfService.errorHandler(error, {
								snackBar: {
									position: 'before'
								}
							});
							this.searchLoader = false;
							Object.keys(this.searchResult).map(key => {
								this.searchResult[key] = [];
							});
						}
					)
						.add(() => {
							this.searchApiStatus = true;
						});
				} else {
					Object.keys(this.searchResult).map(key => {
						this.searchResult[key] = [];
					});
				}
			}, 200);
		}
	}

	dataBuild(data) {
		if (data.resource && data.resource.length) {
			for (const record of data.resource) {
				const cardData: ContentImageCard = {
					title: record.title,
					date: this.gfService.dateFormat(record.createdAt, 'MMM d, y'),
					thumbnail: ''
				};
				if (record.description) {
					cardData.description = record.description;
				}
				if (record.resource.thumbnail) {
					cardData.thumbnail = record.resource.thumbnail;
				}
				if (record.resourceFormat) {
					record.resourceFormat = this.baseService.referenceType('resourceFormat', record.resourceFormat);
					cardData.format = record.resourceFormat.key;
					if (cardData.thumbnail === '') {
						cardData.thumbnail = record.resourceFormat.image;
					}
				}
				record.resourceTypeID = this.baseService.referenceType('resourceType', record.resourceTypeID);
				if (record.resourceTypeID) {
					cardData.type = record.resourceTypeID.caption;
				}
				const extraData = {
					resourceID: record.resourceID,
					createdBy: record.createdBy
				};
				this.searchResult.resource.push(this.gfService.JSONMerge(extraData, cardData));
			}
		}
		if (data.people && data.people.length) {
			for (const record of data.people) {
				const shortInfo = [];
				record.name = `${record.firstName}${record.lastName
					? ' ' + record.lastName
					: ''}`;
				if (record.designation && record.designation.name) {
					shortInfo.push(
						{
							value: record.designation.name
						}
					);
				}
				if (record.company && record.company.name) {
					shortInfo.push(
						{
							value: record.company.name
						}
					);
				}
				if (record.department && record.department.name) {
					shortInfo.push(
						{
							value: record.department.name
						}
					);
				}
				if (record.city && record.city.name) {
					shortInfo.push(
						{
							value: record.city.name
						}
					);
				}
				if (record.location && record.location.name) {
					shortInfo.push(
						{
							value: record.location.name
						}
					);
				}
				record.shortInfo = shortInfo;
			}
			this.searchResult.people = data.people;
		}
	}

	selected(data) {
		if (navigator.onLine) {
			this.searchControl.patchValue(this.searchValue, { emitEvent: false });
		}
	}

	resourceSearch() {
		if (navigator.onLine) {
			this.showSearch = true;
			const queryParams = {
				searchString: this.searchControl.value,
				category: 'all'
			};
			this.resetProcess();
			// this.gfService.blockHttpCall = false;
			this.gfService.routeNavigation('/learning-content/search', queryParams);
		}
	}

	clearSearch() {
		this.resetProcess();
	}

	resetProcess() {
		if (navigator.onLine) {
			if (this.searchSubscribe && !this.searchSubscribe['closed']) {
				this.searchSubscribe.unsubscribe();
			}
			Object.keys(this.searchResult).map(key => {
				this.searchResult[key] = [];
			});
			this.searchControl.reset();
		}
	}

	routeSearchType(type: 'people' | 'resource') {
		if (navigator.onLine) {
			this.showSearch = true;
			const queryParams = {
				searchString: this.searchControl.value
			};
			this.resetProcess();
			// this.gfService.blockHttpCall = false;
			if (type === 'people') {
				this.gfService.routeNavigation('/people/search', queryParams);
			} else if (type === 'resource') {
				this.gfService.routeNavigation('/learning-content/search', queryParams);
			}
		}
	}

	searchResourceDetail(data) {
		if (navigator.onLine) {
			let type = '';
			if (data.createdBy === this.currentUser.userID) {
				type = 'assign_by_me';
			} else {
				type = 'assign_to_me';
			}
			this.resourceDetail(type, data.resourceID);
		}
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.closeTemplate = true;
			this.cdref.detectChanges();
			setTimeout(() => {
				this.baseService.userDetail(data.userID);
			}, 150);
		}
	}

	timeOut() {
		if (navigator.onLine) {
			this.addReadSegmentLog();
			this.getnotificationCount();
			this.interval = setInterval(() => {
				if (navigator.onLine) {
					if (this.isLogin) {
						if ((this.segmentSubscribe === undefined || this.segmentSubscribe.closed) && (this.segmentReadSubscribe === undefined || this.segmentReadSubscribe.closed) && navigator.onLine) {
							this.addReadSegmentLog();
						}
						if ((this.timeLogSubscribe === undefined || this.timeLogSubscribe.closed) && (this.timeLogReadSubscribe === undefined || this.timeLogReadSubscribe.closed) && navigator.onLine) {
							this.addReadTimeLog();
						}
						if ((this.countSubscribe === undefined || this.countSubscribe.closed) && !this.notificationPanelState && navigator.onLine) {
							this.getnotificationCount();
						}
					} else if (this.interval) {
						clearInterval(this.interval);
					}
				}
			}, 10000);
		}
	}

	addReadSegmentLog() {
		let storageData: any = [];
		if (localStorage.getItem('segmentData')) {
			storageData = JSON.parse(localStorage.getItem('segmentData'));
		}
		if (storageData.length && !this.baseService.resourcePopupTriggered) {
			const forkJoinArr = [];
			for (const data of storageData) {
				if ((data.newSegments && data.newSegments.length) || (!data.newSegments && data.hasOwnProperty('currentTime'))) {
					let apiData: any = {};
					if (data.newSegments && data.newSegments.length) {
						data.newSegments = data.newSegments.map(segment => { return Number(segment) });
						apiData = {
							segments: data.newSegments,
							totalSegments: data.totalSegment,
							lastTimeline: data.currentTime
						};
					} else {
						apiData = {
							lastTimeline: data.currentTime
						};
					}
					const headers: any = {};
					forkJoinArr.push(this.resourceApiService.addReadSegmentLog(apiData, data.resourceID, headers));
				} else {
					localStorage.removeItem('segmentData');
				}
			}
			if (forkJoinArr && forkJoinArr.length) {
				this.segmentSubscribe = forkJoin(forkJoinArr).subscribe(
					(response) => {
						if (response && response.length) {
							// const innerForkJoinArr = [];
							// response.map((resp: any, index) => {
							// 	if (storageData[index] && storageData[index].totalSegment) {
							// 		const percentage = resp.readSegmentCount / storageData[index].totalSegment;
							// 		if (percentage >= this.appInit.configuration.videoReadPercentage) {
							// 			const apiData = {};
							// 			const headers: any = {};
							// 			innerForkJoinArr.push(this.resourceApiService.addReadLog(apiData, storageData[index].resourceID, headers));
							// 		}
							// 	}
							// });
							// if (innerForkJoinArr.length) {
							// 	this.segmentReadSubscribe = forkJoin(innerForkJoinArr).subscribe(
							// 		(innerResponse) => { },
							// 		(error) => { }
							// 	)
							// 		.add(() => { });
							// }
							if (response && response.length) {
								const innerForkJoinArr = [];
								response.map((resp: any, index) => {
									if (storageData[index] && resp && resp.read) {
										let parentID;
										let percentage;
										if (storageData[index].playlistParentPercentage) {
											percentage = storageData[index].playlistParentPercentage;
										} else if (storageData[index].courseParentPercentage) {
											percentage = storageData[index].courseParentPercentage;
										}
										if (storageData[index].playlistParentID) {
											parentID = storageData[index].playlistParentID;
										} else if (storageData[index].courseParentID) {
											parentID = storageData[index].courseParentID;
										}
										if (parentID && percentage) {
											const apiData = {
												type: 0,
												percentage: percentage
											};
											const headers: any = {};
											innerForkJoinArr.push(this.resourceApiService.addReadLog(apiData, parentID, headers));
										}
									}
								});
								if (innerForkJoinArr.length) {
									this.segmentReadSubscribe = forkJoin(innerForkJoinArr).subscribe(
										(innerResponse) => { },
										(error) => { }
									)
										.add(() => { });
								}
							}
						}
					},
					(error) => { }
				)
					.add(() => {
						localStorage.removeItem('segmentData');
					});
			}
		}
	}

	addReadTimeLog() {
		let storageData: any = [];
		if (localStorage.getItem('timeLogData')) {
			storageData = JSON.parse(localStorage.getItem('timeLogData'));
		}
		if (storageData.length && !this.baseService.resourcePopupTriggered) {
			const forkJoinArr = [];
			for (const data of storageData) {
				if (data.newTime) {
					const apiData = {
						timeSpent: data.newTime,
						totalTime: data.totalDuration
					};
					if (data.newTime > data.totalDurationInSeconds) {
						data.newTime = data.totalDurationInSeconds;
					}
					const headers: any = {};
					forkJoinArr.push(this.resourceApiService.addReadTimeLog(apiData, data.resourceID, headers));
				} else {
					localStorage.removeItem('timeLogData');
				}
			}
			if (forkJoinArr && forkJoinArr.length) {
				this.timeLogSubscribe = forkJoin(forkJoinArr).subscribe(
					(response) => {
						if (response && response.length) {
							// const innerForkJoinArr = [];
							// response.map((resp: any, index) => {
							// 	if (storageData[index] && storageData[index].totalDuration) {
							// 		const percentage = resp.totalTimeSpent / storageData[index].totalDuration;
							// 		if (percentage >= this.appInit.configuration.pageReadPercentage) {
							// 			const apiData = {};
							// 			const headers: any = {};
							// 			innerForkJoinArr.push(this.resourceApiService.addReadLog(apiData, storageData[index].resourceID, headers));
							// 		}
							// 	}
							// });
							// if (innerForkJoinArr.length) {
							// 	this.timeLogReadSubscribe = forkJoin(innerForkJoinArr).subscribe(
							// 		(innerResponse) => { },
							// 		(error) => { }
							// 	)
							// 		.add(() => { });
							// }
							if (response && response.length) {
								const innerForkJoinArr = [];
								response.map((resp: any, index) => {
									if (storageData[index] && storageData[index].playlistParentPercentage && storageData[index].playlistParentID && resp && resp.read) {
										const apiData = {
											type: 1,
											percentage: storageData[index].playlistParentPercentage
										};
										const headers: any = {};
										innerForkJoinArr.push(this.resourceApiService.addReadLog(apiData, storageData[index].playlistParentID, headers));
									}
								});
								if (innerForkJoinArr.length) {
									this.segmentReadSubscribe = forkJoin(innerForkJoinArr).subscribe(
										(innerResponse) => { },
										(error) => { }
									)
										.add(() => { });
								}
							}
						}
					},
					(error) => { }
				)
					.add(() => {
						localStorage.removeItem('timeLogData');
					});
			}
		}
	}

	getnotificationCount() {
		const apiData = {};
		const header = {};
		this.countSubscribe = this.globalApiService.notificationCount(apiData, header).subscribe(
			(response) => {
				if (response) {
					this.notificationCount = response.recordsCount;
					this.cdref.detectChanges();
				}
			},
			(error) => {
				// this.gfService.errorHandler(error, {
				// 	snackBar: {
				// 		position: 'before'
				// 	}
				// });
			}
		);
	}

	setNotificationPanelHeight() {
		if (this.content && this.content.nativeElement) {
			const el: HTMLElement = this.content.nativeElement;
			this.notificationPanelHeight = (window.innerHeight - el.getBoundingClientRect().height) - 5;
		}
	}

	getNotification(apiData) {
		this.loader = true;
		this.cdref.detectChanges();
		if (this.loaderEl) {
			// this.loaderEl.nativeElement.scrollIntoView();
		}
		this.globalApiService.notifications(apiData).subscribe(
			(response) => {
				if (response && response.records) {
					if (!this.notificationPanelHeight) {
						this.setNotificationPanelHeight();
					}
					this.totalRecordCount = response.totalRecordCount;
					response.records.map((resp, index) => {
						if (this.gfService.moduleName === 'Home' && this.notificationCount && this.canLoadTask && this.notificationCount >= (index + 1)) {
							if (resp.tag && resp.tag.includes('TASK')) {
								this.gfService.globalS$.next(
									{
										type: 'LOAD_TASK',
										data: true
									}
								);
								this.canLoadTask = false;
							}
						}
						const payload: any = {};
						resp.message = resp.payload.message;
						if (resp.payload.action) {
							resp.action = resp.payload.action;
						}
						if (resp.payload.data.Thumbnail) {
							resp.thumbnail = resp.payload.data.Thumbnail.value;
						}
						if (resp.payload.cardAction) {
							resp.cardAction = resp.payload.cardAction;
						}
						resp.category = resp.payload.category;
						Object.keys(resp.payload.data).map((key) => {
							payload[key] = resp.payload.data[key].value;
							if (resp.payload.data[key].hasOwnProperty('link')) {
								payload[key] = `<a href="${resp.payload.data[key].link}">${resp.payload.data[key]
									.value}</a>`;
							}
						});
						if (['answer', 'assignment', 'conversation', 'course', 'resource', 'registration'].includes(resp.category)) {
							if (resp.cardAction.type === 'assignToMe') {
								resp.cardAction.type = 'assign_to_me';
							} else if (resp.cardAction.type === 'assignByMe') {
								resp.cardAction.type = 'assign_by_me';
							}
							if (resp.payload.data.ResourceType) {
								const resourceType = this.baseService.referenceType('resourceType', Number(resp.payload.data.ResourceType.value));
								if (resourceType) {
									payload.ResourceType = resourceType.caption;
								}
								resp.resourceType = payload.ResourceType;
							}
							if (resp.payload.data.hasOwnProperty('ResourceID')) {
								resp.resourceID = resp.payload.data.ResourceID.value;
							}
						} else if (resp.category === 'registerlearning' && resp.payload.data.registerLearningID) {
							resp.registerLearningID = resp.payload.data.registerLearningID.value;
						}
						resp.payload = payload;
						resp.actualEffectiveFrom = resp.effectiveFrom;
						resp.effectiveDate = this.baseService.processTime(resp.effectiveFrom);
						resp.notificationStatus = this.baseService.referenceType('notificationStatus', resp.status);
						delete resp.status;
						this.notifications.push(resp);

					});
					this.cdref.detectChanges();
				}
			},
			(error) => {
				if (this.notifications.length === 0) {
					this.firstTimeOpened = false;
				}
			}
		)
			.add(() => {
				this.loader = false;
			});
	}


	cardAction(data) {
		if (navigator.onLine && !this.blockCardAction) {
			if (data.cardAction && data.cardAction.link) {
				window.location.href = data.cardAction.link;
				this.notificationCount = 0;
			} else {
				if (['answer', 'assignment', 'conversation', 'course', 'resource', 'registration'].includes(data.category)) {
					this.closeTemplate = true;
					this.cdref.detectChanges();
					const queryParams = {
						popup: true,
						resourceID: data.resourceID,
						notification: true
					};
					// data.status = 2;
					data.notificationStatus = this.baseService.referenceType('notificationStatus', data.notificationStatus.value);
					this.router.navigate([], { relativeTo: this.activatedRoute, queryParamsHandling: 'merge', queryParams });
					if (data.cardAction) {
						this.resourceDetail(data.cardAction.type);
					}
					this.notificationCount = 0;
				}
			}
		}
	}

	resourceDetail(type, resourceID?: number) {
		const componentData = [
			{
				variableName: 'type',
				value: type
			}
		];
		if (resourceID) {
			componentData.push(
				{
					variableName: 'actualResourceID',
					value: resourceID
				}
			);
		}

		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceDetailComponent,
				componentData
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
				const queryParams = {
					popup: null,
					resourceID: null,
					notification: null
				};
				this.router.navigate([], {
					relativeTo: this.activatedRoute,
					queryParamsHandling: 'merge',
					queryParams
				});
			}
		});
	}

	profile() {
		if (navigator.onLine) {
			this.closeTemplate = true;
			this.cdref.detectChanges();
			if (this.gfService.moduleName !== 'People') {
				this.gfService.globalBS$.next(
					{
						type: 'PAGE_LOADER',
						loader: true
					}
				);
			}
			this.gfService.routeNavigation('/people/profile');
		}
	}

	toggleNotification(state) {
		this.closeTemplate = false;
		this.notificationPanelState = state;
		if (!this.firstTimeOpened && state) {
			this.getNotification({ limit: this.limit });
		}
		if (state) {
			if (this.notifications.length) {
				for (const notification of this.notifications) {
					notification.effectiveDate = this.baseService.processTime(notification.effectiveFrom);
				}
			}
			this.firstTimeOpened = true;
			if (this.notificationCount && this.notifications.length) {
				this.canLoadTask = true;
				this.notifications = [];
				this.getNotification({ limit: this.limit });
			}
		} else {
			this.notificationCount = 0;
		}
	}

	actions(action, data, additionalData: any = {}) {
		if (navigator.onLine) {
			this.blockCardAction = true;
			if (['answer', 'assignment', 'conversation', 'course', 'resource', 'registerlearning'].includes(data.category)) {
				this.closeTemplate = true;
				this.cdref.detectChanges();
				const queryParams: any = {
					popup: true,
					notification: true
				};
				if (data.category !== 'registerlearning') {
					queryParams.resourceID = data.resourceID;
				} else if (data.category === 'registerlearning') {
					queryParams.registerLearningID = data.registerLearningID;
				}
				// data.status = 2;
				data.notificationStatus = this.baseService.referenceType('notificationStatus', data.notificationStatus.value);
				this.router.navigate([], { relativeTo: this.activatedRoute, queryParamsHandling: 'merge', queryParams });
				if (data.category !== 'registerlearning') {
					this.resourceDetail(data.cardAction.type);
				} else if (data.category === 'registerlearning') {
					this.certificationDetail(data);
				}
				this.notificationCount = 0;
				setTimeout(() => {
					this.blockCardAction = false;
				});
			}
		}
		// if (data.resourceType && data.resourceType.key === 'knowledgecard' && data.resourceID) {
		// 	if (['assignmentEvaluate', 'assignmentSubmit'].includes(action)) {
		// 		this.notificationCount = 0;
		// 		// this.router.navigate(['assignment'], { queryParams: { popup: true, resourceID: data.resourceID } });
		// 	}
		// }
		// this.closeTemplate = true;
	}

	onSidenavToggle() {
		const data: any = {
			type: 'BURGER',
			state: !this.sideNavState
		}
		this.gfService.globalBS$.next(data);
		this.sideNavState = !this.sideNavState;
	}

	loadMoreNotification(event) {
		if (navigator.onLine) {
			if (event.bottom) {
				if (this.notifications.length < this.totalRecordCount && !this.loader) {
					this.getNotification({
						limit: this.limit,
						beforeid: this.notifications[this.notifications.length - 1].notificationID
					});
				}
			}
		}
	}

	logout() {
		this.closeTemplate = true;
		this.gfService.globalBS$.next(
			{
				type: 'PAGE_LOADER',
				loader: true
			}
		);
		const header = {};
		const apiData = {};
		const token = this.gfService.getCookie('token');
		this.gfService.deleteCookie('token');
		this.gfService.sessionUser = null;
		this.appInit.sessionUser = null;
		this.gfService.globalBS$.next({
			type: 'MODULE_NAME',
			name: null
		});
		this.gfService.globalBS$.next({
			type: 'IS_LOGIN',
			isLogin: false
		});
		this.gfService.loginState.next(false);

		// this.gfService.lastParentMenu = [];
		// this.gfService.blockHttpCall = false;
		this.authApiService.logout(apiData, header, token).subscribe(
			(response) => {
			},
			(error) => { }
		)
			.add(() => {
				this.gfService.routeNavigation('/auth/login');
				this.gfService.globalBS$.next(
					{
						type: 'PAGE_LOADER',
						loader: false
					}
				);
				// this.gfService.blockHttpCall = true;
			});
	}

	changeLanguage(lang) {
		if (navigator.onLine) {
			this.language = lang;
			sessionStorage.setItem('locale', this.language);
			this.locale.switchLanguage(lang);
			// this.gfService.globalBS$.next(
			// 	{
			// 		type: 'PAGE_LOADER',
			// 		loader: true
			// 	}
			// );
		}
	}

	updatePreference(actionEl) {
		this.closeTemplate = true;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			maxWidth: '860px',
			data: {
				action: 'updatePreference',
				triggerEl: actionEl
			},
			disableClose: true,
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
		});
	}

	certificationDetail(data) {
		const record: any = {
			registerLearningID: data.registerLearningID
		};
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PeopleFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'certificationDetail'
					},
					{
						variableName: 'record',
						value: record
					},
					// {
					// 	variableName: 'userID',
					// 	value: this.userID
					// },
					// {
					// 	variableName: 'userData',
					// 	value: {
					// 		// name: this.basicProfileData.name,
					// 		userID: data.userID
					// 	}
					// }
				]
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				const queryParams = {
					popup: null,
					registerLearningID: null,
					notification: null
				};
				this.router.navigate([], {
					relativeTo: this.activatedRoute,
					queryParamsHandling: 'merge',
					queryParams
				});
			}
		});
	}

	bookmarkDetail() {
		this.closeTemplate = true;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('../modules/resource/bookmarks/bookmarks.component'),
				componentData: []
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
		});
	} 

	routeHome() {
		if (navigator.onLine) {
			this.gfService.routeNavigation('/home');
		}
	}

	ngOnDestroy() {
		this.shortInfo = [];
		if (this.subscribe) {
			this.subscribe.unsubscribe();
		}
	}
}
